<div>
  <div class="girdle">
    <img src="../../../assets/new/bottom-banner.png">
  </div>
  <div class="bottom">
    <img src="../../../assets/images/shouye/logo.png" class="logo-img">
    <div class="contact">
      <span style="color: #333333;font-family: Microsoft YaHei UI;">感谢您关注IvorySQL 2025生态大会</span><br>
      <span style="color: #333333;font-family: Microsoft YaHei UI;">大会相关问题请发送邮件至 : conference@ivorysql.org</span> <br>
      <a href="http://beian.miit.gov.cn/">鲁ICP备09010331号</a>
    </div>
    <div style="text-align:center;">
      <img src="../../../assets/images/shouye/qrcode.jpg" width="100px">
      <div class="foot-desc">随时关注会议动态</div>
    </div>
  </div>
  <hr>
</div>
